import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import smartLendLogo from "./img/sl_long_new_logo_wo_beta.png";
import "./CBSPartner.css";

const faqItems = [
  {
    title: "What is SmartLend?",
    answer: (
      <>
        <p>
          SmartLend is a <span className="cbs-zf">ZERO-FEE</span> financing
          marketplace that helps individuals and businesses compare loan options
          with ease.
        </p>
        <p>
          Whether you are looking for a business loan or a personal loan, submit
          one application and we will match you with multiple banks and licensed
          financial institutions.
        </p>
        <p>
          <b>
            One Application. Multiple Lenders.{" "}
            <span className="cbs-zf">ZERO-FEE</span>. Smarter Financing.
          </b>
        </p>
      </>
    ),
  },
  {
    title: "What's the catch?",
    answer: (
      <>
        <p>
          <b>There is not one.</b> SmartLend is a financing marketplace that
          matches your application with suitable banks and licensed lenders, all
          at no cost to you.
        </p>
        <p>
          You also have a dedicated Relationship Manager to guide you through the
          process, answer questions, and help you understand your financing
          options.
        </p>
        <p>
          For businesses that need more hands-on assistance, we offer an
          optional Concierge Service. It is entirely optional, and fees are
          always disclosed upfront.
        </p>
      </>
    ),
  },
  {
    title: "Who is eligible?",
    answer: (
      <>
        <p>
          This offer is available to Singapore SME owners and company directors
          of a locally incorporated Singapore company.
        </p>
        <p>
          Whether you plan to apply for financing, refinance existing
          facilities, or simply understand your standing before approaching
          lenders, you can claim your complimentary CBS report.
        </p>
      </>
    ),
  },
  {
    title: "Is the CBS report really free?",
    answer: (
      <p>
        <b>Yes, S$0.</b> The report usually costs S$8.72 incl. GST when
        purchased directly. For a limited time, our official promotional campaign with
        Credit Bureau Singapore covers it. No card required, and no obligation
        to take a loan afterwards.
      </p>
    ),
  },
  {
    title: "Will checking my CBS report hurt my credit score?",
    answer: (
      <>
        <p>
          Reviewing your own CBS report before applying is a smart move. It
          helps you understand your credit standing before submitting
          applications.
        </p>
        <p>By checking your CBS report first, you can:</p>
        <ul>
          <li>Spot and correct possible errors.</li>
          <li>Understand your current credit profile.</li>
          <li>Avoid unnecessary loan applications that may be rejected.</li>
          <li>Improve your chances of securing suitable financing.</li>
        </ul>
      </>
    ),
  },
  {
    title: "What will I actually see in my report?",
    answer: (
      <p>
        Your repayment history, existing credit facilities, past enquiries, and
        any defaults: the same data lenders see. SmartLend adds what CBS does
        not: a plain-English analysis of your Balance-to-Income ratio and which
        loan products your profile realistically fits.
      </p>
    ),
  },
  {
    title: "How is this different from buying the report from CBS directly?",
    answer: (
      <p>
        Buying direct gets you the same report at S$8.72 incl. GST, and it is
        on you to interpret it. Through SmartLend it is free for a limited time,
        and it comes with an expert read-through and lender matching if you want
        it. Same data, more clarity, S$0.
      </p>
    ),
  },
  {
    title: "What if my report shows problems?",
    answer: (
      <p>
        That is the best time to find out. Your Relationship Manager will walk
        you through what is hurting your profile, what can be corrected, and
        what to strengthen before applying.
      </p>
    ),
  },
  {
    title: "Is my data safe? Who sees my report?",
    answer: (
      <p>
        Uploading your report to SmartLend is optional. If you do, it is stored
        securely, used only to prepare your personal analysis, and never shared
        with any lender or third party without your explicit consent.
      </p>
    ),
  },
  {
    title: "Do I have to take a loan afterwards?",
    answer: (
      <p>
        No. The report and consultation are free with no strings attached. If
        you want to explore financing, we are ready. If not, you walk away
        knowing where you stand.
      </p>
    ),
  },
];

const benefits = [
  {
    icon: "star",
    title: "S$0 - on us, for a limited time",
    body: (
      <>
        Your official CBS Credit Report, usually <b>S$8.72 incl. GST</b>, at no
        cost under our promotional campaign with Credit Bureau Singapore. Check your
        credit health before any lender does.
      </>
    ),
  },
  {
    icon: "bars",
    title: "Know your borrowing power",
    body: (
      <>
        We analyse your Balance-to-Income ratio so you know what you can
        realistically borrow <b>before</b> you apply. No guesswork, no wasted
        applications.
      </>
    ),
  },
  {
    icon: "person",
    title: "A human who's read thousands of these",
    body: (
      <>
        Free consultation with an experienced Relationship Manager. Plain-English
        answers on which products fit your profile, what terms to expect, and
        what to fix first.
      </>
    ),
  },
  {
    icon: "shield",
    title: "Your data stays yours",
    body: (
      <>
        Uploading your report is optional. If you do, it is stored securely,
        used solely for your analysis, and never shared without your consent.
      </>
    ),
  },
];

const googleReviews = [
  {
    avatar: "J",
    name: "joel.",
    meta: "Google review excerpt · 2 months ago",
    quote:
      "Signed up for an account on their site to redeem my free CBS report. Code provided initially did not work, however I was pleasantly surprised to receive a call from Chermaine, and she did not hesitate to provide me with a new code after I ...",
  },
  {
    avatar: "A",
    name: "Ahmad Firdaus",
    meta: "Google review excerpt · a month ago",
    quote:
      "Miss Chermaine Wong has been an outstanding loan broker to work with. From the very beginning, he demonstrated genuine care and professionalism. What stood out the most was her patience - she never rushed me and took the time to explain every ...",
  },
  {
    avatar: "F",
    name: "Favian Hosain",
    meta: "Google review · 5 months ago",
    quote:
      "Victoria was very helpful and professional. She's knowledgeable, patient, and gives good advice based on your situation. She gave clear and honest advice, explained all the options well. Highly recommended broker 👍👍👍👍👍 for her!!",
  },
  {
    avatar: "J",
    name: "June Chen",
    meta: "Google review · 3 weeks ago",
    quote:
      "We've enjoyed working with SmartLend as a partner. Victoria and the team is professional, responsive, and easy to collaborate with. Their streamlined approach to SME financing adds real value to businesses, and we look forward to continuing our partnership.",
  },
  {
    avatar: "D",
    name: "Dawson Lym",
    meta: "Google review · 3 weeks ago",
    quote:
      "I must say Chermaine Wong, Business Development Executive from Smartlend, did a great and professional job by being swift and decisive with the decisions. I ended up being able to get a loan. Despite being rejected few times with other ML company's. Well done!",
  },
  {
    avatar: "B",
    name: "Bart Jeung",
    meta: "Google review · 10 months ago",
    quote:
      "As a partner with SmartLend, Choco Up appreciates the platform's integrity and initiative in enabling SME borrowers to access funding without incurring additional platform fees. This transparency not only builds trust but also helps us achieve higher closure rates.",
  },
];

function BenefitIcon({ type }) {
  if (type === "bars") {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M4 20V10M10 20V4M16 20v-8M22 20H2"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  }

  if (type === "person") {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="7.5" r="4.5" fill="currentColor" />
        <path
          d="M3 21c1.6-4.4 5-6.5 9-6.5s7.4 2.1 9 6.5"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === "shield") {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M12 1.5l8.5 3.2v6.3c0 5.9-3.6 10-8.5 11.8C7.1 21 3.5 16.9 3.5 11V4.7z"
          fill="currentColor"
        />
        <path
          d="M8.2 11.6l2.7 2.7 4.9-5.4"
          stroke="#F7C825"
          strokeWidth="2.2"
          fill="none"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 1.5l2.9 6 6.6.8-4.9 4.6 1.3 6.6L12 16.3l-5.9 3.2 1.3-6.6L2.5 8.3l6.6-.8z"
        fill="currentColor"
      />
    </svg>
  );
}

function CBSPartner() {
  const [openFaq, setOpenFaq] = useState(0);

  const startSignup = () => {
    Cookies.set("signupthroughcbs", 1);
    window.location.href = "https://smart-lend.com/auth/signup?ecid=cbs";
  };

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".cbs-reveal"));

    if (!("IntersectionObserver" in window)) {
      elements.forEach((element) => element.classList.add("in"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("in");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="cbs-page">
      <nav className="cbs-nav">
        <div className="cbs-wrap cbs-navin">
          <div className="cbs-brand">
            <img
              className="cbs-logo"
              src={smartLendLogo}
              alt="SmartLend"
            />
            {/* <span className="cbs-part">
              Official partner of
              <br />
              <b>Credit Bureau Singapore</b>
            </span> */}
          </div>
          <button className="cbs-navcta" type="button" onClick={startSignup}>
            Get My Free Report
          </button>
        </div>
      </nav>

      <section className="cbs-hero">
        <div className="cbs-wrap cbs-herogrid">
          <div>
            <span className="cbs-chip">
              <span className="cbs-pulse" />
              SmartLend x Credit Bureau Singapore · Limited-time offer
            </span>
            <h1>
              Know what lenders see - <span>before they do.</span>
            </h1>
            <p className="cbs-lede">
              Every loan decision starts with your CBS Credit Report. Get yours{" "}
              <b>free</b>, with a plain-English analysis of your credit health
              and the loan options your business actually qualifies for.
            </p>

            <div className="cbs-pricemoment">
              <div className="cbs-was">
                S$8.72<small>incl. GST</small>
              </div>
              <div className="cbs-arrow">→</div>
              <div className="cbs-now">
                S$0<small>LIMITED TIME</small>
              </div>
            </div>

            <div className="cbs-heroctas">
              <button className="cbs-btn" type="button" onClick={startSignup}>
                Get My Free CBS Report <span>→</span>
              </button>
              <a className="cbs-btn cbs-ghost" href="#how">
                How it works
              </a>
            </div>

            <div className="cbs-assure">
              <span>
                <b>✓</b> No card required
              </span>
              <span>
                <b>✓</b> 2 minutes
              </span>
              <span>
                <b>✓</b> Know before you apply
              </span>
            </div>
          </div>

          <div className="cbs-panel" aria-hidden="true">
            <div className="cbs-glow" />
            <div className="cbs-repcard">
              <span className="cbs-zerochip">FREE · S$0</span>
              <div className="cbs-cardtop">
                <span>Your Credit Report</span>
                <b>OFFICIAL CBS DATA</b>
              </div>
              <div className="cbs-dial">
                <svg viewBox="0 0 216 124" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M24 112 A84 84 0 0 1 192 112"
                    fill="none"
                    stroke="#F0EDFF"
                    strokeWidth="16"
                    strokeLinecap="round"
                  />
                  <path
                    d="M24 112 A84 84 0 0 1 157 41"
                    fill="none"
                    stroke="#7057F6"
                    strokeWidth="16"
                    strokeLinecap="round"
                  />
                  <circle
                    cx="157"
                    cy="41"
                    r="10"
                    fill="#fff"
                    stroke="#F7C825"
                    strokeWidth="5"
                  />
                  <text
                    x="108"
                    y="92"
                    textAnchor="middle"
                    fill="#241B4F"
                    fontFamily="Sora, sans-serif"
                    fontWeight="800"
                    fontSize="38"
                  >
                    ??
                  </text>
                  <text
                    x="108"
                    y="114"
                    textAnchor="middle"
                    fill="#5D6680"
                    fontFamily="Inter, sans-serif"
                    fontWeight="700"
                    fontSize="10"
                    letterSpacing="1.5"
                  >
                    REVEALED FREE, IN MINUTES
                  </text>
                </svg>
              </div>
              <div className="cbs-rrow">
                <span>Repayment history</span>
                <b>✓ Included</b>
              </div>
              <div className="cbs-rrow">
                <span>Existing facilities</span>
                <b>✓ Included</b>
              </div>
              <div className="cbs-rrow">
                <span>Balance-to-Income ratio</span>
                <strong>Analysed for you</strong>
              </div>
              <div className="cbs-rrow">
                <span>Lender-readiness review</span>
                <strong>Free consult</strong>
              </div>
              <div className="cbs-lenderchip">
                👁 Lenders check this before every approval
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="cbs-marquee" aria-hidden="true">
        <div className="cbs-mtrack">
          {Array.from({ length: 2 }).map((_, index) => (
            <React.Fragment key={index}>
              <span>Official CBS Data</span>
              <span>★</span>
              <span>Free for a limited time</span>
              <span>★</span>
              <span>Usually S$8.72 incl. GST</span>
              <span>★</span>
              <span>No card required</span>
              <span>★</span>
              <span>2 minutes</span>
              <span>★</span>
              <span>Know before you apply</span>
              <span>★</span>
              <span>
                One Application · Multiple Lenders ·{" "}
                <span className="cbs-zf">ZERO-FEE</span>
              </span>
              <span>★</span>
            </React.Fragment>
          ))}
        </div>
      </div>

      <section className="cbs-sec" id="how">
        <div className="cbs-wrap">
          <div className="cbs-sechead cbs-reveal">
            <span className="cbs-eyebrow">How it works</span>
            <h2>Free report to funded - in three steps</h2>
            <p>
              No obligation at any step. Many owners claim the report just to
              know where they stand.
            </p>
          </div>
          <div className="cbs-steps">
            {[
              [
                "01",
                "Claim your report",
                "Retrieve your official CBS Credit Report in about two minutes, at S$0. No card, no paperwork beyond the basics.",
              ],
              [
                "02",
                "Get your analysis",
                "Upload it to our portal and we translate it into plain English: credit health, Balance-to-Income ratio, and anything that could quietly cost you an approval.",
              ],
              [
                "03",
                "See your real options",
                "One conversation with a Relationship Manager, and we match you against lenders you actually qualify for. Compare offers, then decide.",
              ],
            ].map(([number, title, copy]) => (
              <div className="cbs-stepcard cbs-reveal" key={number}>
                <span className="cbs-ghostnum">{number}</span>
                <span className="cbs-tag">STEP {Number(number)}</span>
                <h3>{title}</h3>
                <p>{copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cbs-sec cbs-alt">
        <div className="cbs-wrap">
          <div className="cbs-sechead cbs-reveal">
            <span className="cbs-eyebrow">Why through SmartLend</span>
            <h2>The report is free. The clarity is the point.</h2>
            <p>
              Anyone can hand you a PDF of numbers. We tell you what those
              numbers mean for your next loan.
            </p>
          </div>
          <div className="cbs-bens">
            {benefits.map((benefit) => (
              <div className="cbs-ben cbs-reveal" key={benefit.title}>
                <span className="cbs-ic">
                  <BenefitIcon type={benefit.icon} />
                </span>
                <h3>{benefit.title}</h3>
                <p>{benefit.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cbs-sec cbs-matter">
        <div className="cbs-wrap cbs-mattergrid">
          <div className="cbs-reveal">
            <span className="cbs-eyebrow">Why it matters</span>
            <h2>One report decides your rate, your limit, your approval.</h2>
            <p className="cbs-big">
              Every lender in Singapore checks your CBS report before saying
              yes. A strong profile unlocks better rates and higher limits. A
              weak one, <b>or an error you never knew about</b>, can quietly
              kill an application.
            </p>
            <div className="cbs-mstats">
              <div className="cbs-mstat">
                <div>Errors happen</div>
                <p>
                  Outdated facilities and mistaken records appear on reports
                  more often than owners expect.
                </p>
              </div>
              <div className="cbs-mstat">
                <div>Rejections leave marks</div>
                <p>
                  Every failed application shows up as an enquiry. Applying
                  blind, repeatedly, makes the next approval harder.
                </p>
              </div>
            </div>
          </div>
          <div className="cbs-reveal">
            <div className="cbs-dialcard">
              <p>What lenders weigh</p>
              <svg viewBox="0 0 330 194" xmlns="http://www.w3.org/2000/svg">
                <g
                  fontFamily="Inter, sans-serif"
                  fontSize="12.5"
                  fontWeight="600"
                  fill="#5D6680"
                >
                  <text x="0" y="30">
                    Repayment history
                  </text>
                  <text x="0" y="72">
                    Existing debt (BTI)
                  </text>
                  <text x="0" y="114">
                    Credit enquiries
                  </text>
                  <text x="0" y="156">
                    Defaults &amp; delinquency
                  </text>
                </g>
                {[
                  [18, 154, "#7057F6"],
                  [60, 124, "#7057F6"],
                  [102, 84, "#F7C825"],
                  [144, 144, "#7057F6"],
                ].map(([y, width, color]) => (
                  <g key={y}>
                    <rect
                      x="158"
                      y={y}
                      width="164"
                      height="15"
                      rx="7.5"
                      fill="#F0EDFF"
                    />
                    <rect
                      x="158"
                      y={y}
                      width={width}
                      height="15"
                      rx="7.5"
                      fill={color}
                    />
                  </g>
                ))}
              </svg>
              <span>
                All four live in your CBS report.
                <br />
                <b>See yours before you apply.</b>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="cbs-sec">
        <div className="cbs-wrap">
          <div className="cbs-sechead cbs-reveal">
            <span className="cbs-eyebrow">What owners say</span>
            <h2>Real Google reviews from SmartLend customers</h2>
          </div>
          <div className="cbs-quotes">
            {googleReviews.map(({ avatar, name, meta, quote }) => (
              <div className="cbs-quote cbs-reveal" key={`${name}-${meta}`}>
                <span className="cbs-qmark">”</span>
                <div className="cbs-stars">★★★★★</div>
                <p>{quote}</p>
                <div className="cbs-who">
                  <span>{avatar}</span>
                  <div>
                    <b>{name}</b>
                    <small>{meta}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cbs-sec cbs-alt" id="faq">
        <div className="cbs-wrap cbs-faqgrid">
          <div className="cbs-faqleft cbs-reveal">
            <span className="cbs-eyebrow">FAQ</span>
            <h2>You asked, we answered.</h2>
            <p>
              Can't find your question? View all our{" "}
              <a href="/frequentlyaskedquestions">FAQs</a>, chat with us on{" "}
              <a href="https://wa.me/6587853373">WhatsApp</a>, or email{" "}
              <a href="mailto:hello@smart-lend.com">hello@smart-lend.com</a>.
            </p>
          </div>
          <div>
            {faqItems.map((item, index) => {
              const isOpen = openFaq === index;
              return (
                <div
                  className={`cbs-qa ${isOpen ? "open" : ""}`}
                  key={item.title}
                >
                  <button type="button" onClick={() => setOpenFaq(isOpen ? -1 : index)}>
                    {item.title}
                    <span>+</span>
                  </button>
                  <div className="cbs-ans">{item.answer}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <div className="cbs-finalwrap">
        <div className="cbs-final cbs-reveal">
          <p>
            <s>S$8.72 incl. GST</s> &nbsp;→&nbsp; <em>S$0 · Limited time</em>
          </p>
          <h2>Your report is ready when you are.</h2>
          <span>
            Official CBS data · No card · No obligation · Takes about 2 minutes
          </span>
          <button className="cbs-btn" type="button" onClick={startSignup}>
            Get My Free CBS Report <b>→</b>
          </button>
          <small>Know where you stand before you apply.</small>
        </div>
      </div>

      <footer className="cbs-footer">
        <div className="cbs-wrap">
          <div className="cbs-fgrid">
            <div className="cbs-fcol">
              <div className="cbs-fbrand">
                <img
                  className="cbs-logo"
                  src={smartLendLogo}
                  alt="SmartLend"
                />
              </div>
              <p>
                A <span className="cbs-zf">ZERO-FEE</span> financing marketplace
                for individuals and businesses.
              </p>
              <p>
                <b>
                  One Application. Multiple Lenders.{" "}
                  <span className="cbs-zf">ZERO-FEE</span>. Smarter Financing.
                </b>
              </p>
            </div>
            <div className="cbs-fcol">
              <h4>Partner with us</h4>
              <p>
                NBFCs, P2P platforms, family offices, fintech lenders and
                alternative debt funds: join our lending ecosystem.
              </p>
              <a href="mailto:hello@smart-lend.com">Contact us →</a>
            </div>
            <div className="cbs-fcol">
              <h4>Contact</h4>
              <p>
                <a href="mailto:hello@smart-lend.com">hello@smart-lend.com</a>
                <br />
                <a href="https://wa.me/6587853373">WhatsApp us</a>
                <br />
                <a href="/frequentlyaskedquestions">FAQs</a>
              </p>
            </div>
          </div>
          <p className="cbs-legal">
            © 2026 SmartLend. All rights reserved. SmartLend is a loan
            marketplace and does not itself provide credit facilities. All loan
            approvals, rates and terms are determined by the respective lenders.
          </p>
        </div>
      </footer>
    </main>
  );
}

export default CBSPartner;
